import { render } from "./StandardPage.vue?vue&type=template&id=81483592"
import script from "./StandardPage.vue?vue&type=script&lang=js"
export * from "./StandardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__